import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase/firebase";
import { useNavigate } from "react-router";
import { collection, query, where, getDocs } from 'firebase/firestore';
import signin from "../../assets/img/signin.jpg";
import styles from "./signin.module.css"; // Import CSS Module
import Header from "../../components/header/header/header";
import "../../assets/vendor/bootstrap-icons/bootstrap-icons.css";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError("Email et mot de passe sont requis.");
      return;
    }

    // Convert email to lowercase for processing
    const normalizedEmail = email.toLowerCase();

    try {
      // First, check if email exists in candidates collection
      const candidatesRef = collection(db, 'candidates');
      const candidateQuery = query(candidatesRef, where('email', '==', normalizedEmail));
      const candidateSnapshot = await getDocs(candidateQuery);

      if (!candidateSnapshot.empty) {
        setError("Veuillez compléter votre inscription pour pouvoir se connecter.");
        return;
      }

      // Check if email exists in medecins collection
      const medecinsRef = collection(db, 'medecins');
      const medecinQuery = query(medecinsRef, where('email', '==', normalizedEmail));
      const medecinSnapshot = await getDocs(medecinQuery);

      if (medecinSnapshot.empty) {
        setError("Compte non trouvé. Veuillez vérifier vos informations.");
        return;
      }

      // If email is in medecins and not in candidates, proceed with login
      await signInWithEmailAndPassword(auth, normalizedEmail, password);
      
      // Redirect to /profile after successful login
      navigate("/profile");
    } catch (error) {
      setError("Échec de la connexion. Veuillez vérifier vos informations.");
    }
  };

  return (
    <div>
      <Header/>
      {/* Main Content */}
      <main className={styles.mainContent}>
        <div className={styles.loginCard}>
          <div className={styles.loginImage}>
            <img src={signin} alt="Hero" className={styles.heroImage} />
          </div>
          <div className={styles.loginFormContainer}>
            <p className={styles.loginTitle}>
              Explorez le prochain niveau d'efficacité avec CliP !
            </p>
            <p className={styles.description}>
              Accédez à CliP (Clinician Communication Platform de Diamond) pour
              une expérience immersive de planification et de suivi des traitements de vos patients.
            </p>
            <form className={styles.loginForm} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={styles.inputField}
                />
              </div>
              <div className={styles.formGroup} style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className={styles.inputField}
                />
                <span
                  style={{ position: "absolute", right: 16, top: "50%", transform: "translateY(-50%)", cursor: "pointer", zIndex: 2 }}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                </span>
              </div>

              {error && <div className={styles.errorMessage}>{error}</div>}

              <button type="submit" className={styles.loginButton}>
                Log in
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Signin;
